import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { RotatingLines } from "react-loader-spinner"
import Travelpayouts from './affiliazioni/travelpayouts'
import 'swiper/css'

function AutoNoleggio({ flag, flag2, flag3, lat, lng, onChiudi, dettagliIsOpen }) {
    const [noleggi, setNoleggi] = useState([])//trovati in google API places(new)
    const [noleggio, setNoleggio] = useState(null)
    const [msg, setMsg] = useState({ noleggioNotFound: null })
    const [isLoading, setIsLoading] = useState(true)

    const dettagliRef = useRef()

    async function getAutoNoleggio() {
        try {
            const res = await axios.get(`/autoNoleggio/${lat}/${lng}`)//places oggetto e routingSummaries alro oggetto
            if (Object.keys(res.data.datiByGooglePlaces).length !== 0) {
                setIsLoading(false)
                const nuovoArray = res.data.datiByGooglePlaces.places.map((item, index) => ({//places e routingSummaries in unico oggetto
                    ...item,
                    ...res.data.datiByGooglePlaces.routingSummaries[index]
                }))
                setNoleggi(nuovoArray)
            } else {
                setMsg({ noleggioNotFound: '*** Nessun auto noleggio trovato ***' })
                document.getElementById('rotary').style.display = 'none'
            }
        } catch (err) { console.log(err) }
    }
    function dettagli(e) {
        dettagliIsOpen('secondoNoleggi')
        const noleggio = noleggi.filter((item, index) => index === e)[0]
        setNoleggio(noleggio)
    }

    useEffect(() => {
        if (flag === 'primoNoleggi' && noleggi.length === 0 && lat) {
            setMsg({ noleggioNotFound: null }); getAutoNoleggio(); document.getElementById('rotary').style.display = 'block'
        }
    }, [lat, flag])

    useEffect(() => { console.log(noleggio) }, [noleggio])
    return (<>
        <div className={`divNotifiche${flag === 'primoNoleggi' || flag2 === 'secondoNoleggi' || flag3 === 'terzoNoleggi' ? 'Aperto' : ''}`}
            style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>

            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={onChiudi}>◀
            </button>

            {isLoading && <p className='mt-1 text-center'>
                <RotatingLines strokeColor='silver' strokeWidth='5' animationDuration='5' width='26' />
            </p>
            }
            <div style={{ margin: '0 3px', overflowY: 'scroll', height: '90%' }}>
                <p className='text-center fs-5'><i>{msg.noleggioNotFound}</i></p>
                {noleggi.length !== 0 && //da google
                    noleggi.map((albergo, index) => (
                        <div style={{ borderBottom: '1px solid lightgrey', display: 'grid', gridTemplateColumns: '1fr', gap: '5px', cursor: 'pointer', margin: '8px 0' }}
                            onClick={() => { dettagli(index) }} key={index}>
                            <p><span style={{ backgroundColor: 'gainsboro', borderRadius: '7px', padding: '3px', fontWeight: '600' }}>{albergo.displayName.text}</span> <i style={{ opacity: '.6' }}>{albergo.formattedAddress}</i></p>
                        </div>
                    ))}
            </div>
        </div>

        {/* ------------------------ BANNER DETTAGLI HOTEL DA GOOGLE --------------------------- */}
        <div className={`divNotifiche${flag2 === 'secondoNoleggi' || flag3 === 'terzoAlberghi' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}
            ref={dettagliRef}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={onChiudi}>◀
            </button><hr />
            {noleggio &&
                <div style={{ textAlign: 'center', overflowY: 'scroll', height: '90%' }}>
                    {/* ---------------- IMMAGINE ---------------------- */}
                    <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                        {noleggio.photos &&
                            noleggio.photos.map((photo, index) => (
                                <div className="scrollmenu_risto" key={index + 'google'}>
                                    <img src={`https://places.googleapis.com/v1/${photo.name}/media?key=${process.env.REACT_APP_GOOGLE_MAPS}&maxWidthPx=250&maxHeightPx=250`}
                                        style={{ width: '22em', height: '18em', objectFit: 'cover' }} role="button" alt='' />
                                </div>
                            ))}
                    </div>

                    {/* ----------------- NOME E INDIRIZZO ---------------  */}
                    <div className='mt-5'>
                        <div style={{ textAlign: 'left', fontSize: 'x-large', margin: '0 10px', fontFamily: 'serif' }}>
                            <p>{noleggio.displayName.text}</p>
                            <p style={{ fontSize: 'large', opacity: '.8' }}>{noleggio.formattedAddress}</p>

                            <p className='fs-6'>
                                <img src={require('../image/icons8-telefono-cellulare-48.png')} width={'30px'} alt='' /> {noleggio.nationalPhoneNumber}
                            </p><hr />
                            <p className='fs-5'>
                                <img src={require('../image/icons8-visita-24.png')} alt='' /> {(noleggio.legs[0].distanceMeters / 1000).toFixed(1)} km
                            </p>
                            <Travelpayouts restaurantName={noleggio.displayName.text} address={noleggio.formattedAddress} />
                        </div><hr />
                    </div>
                </div>
            }
        </div>
    </>)
}
export default AutoNoleggio